import { render, staticRenderFns } from "./ClientVerificationPicker.vue?vue&type=template&id=2a004f38&scoped=true&"
import script from "./ClientVerificationPicker.vue?vue&type=script&lang=js&"
export * from "./ClientVerificationPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a004f38",
  null
  
)

export default component.exports